// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1apLK","controls":"styles_controls__1ARkl","charLimit":"styles_charLimit__1l3YP","input":"styles_input__17qYH","send":"styles_send__22dk5"};